

import { mapActions, mapState } from 'vuex'
import utils from '@/components/tools/utils'

export default {
  name: 'AgbPopup',
  props: {
    content: {
      type: String,
      default: ''
    },
    title: {
      type: String,
      default: ''
    },
    validFrom: {
      type: String,
      default: undefined
    },
    changes: {
      type: String,
      default: undefined
    },
    showDialog: {
      type: Boolean
    }

  },
  data () {
    return {
      dialog: false
    }
  },

  computed: {
    ...mapState('customer', ['customer']),

    dialogWidth: {
      get () {
        if (this.$vuetify.breakpoint.mobile) {
          return '100%'
        } else {
          return '60%'
        }
      },
      set (value) {
      }
    }
  },

  created () {
    this.dialog = this.showDialog
  },

  methods: {
    ...mapActions('customer', ['getCustomer']),
    async accept () {
      this.dialog = false
      await this.$axios.post('/private/customer/accept-tac', {})
      await this.getCustomer()
    },
    formatDate (value) {
      return utils.formatDateWithoutTime(value)
    }
  }

}
